import { jsx as _jsx } from "preact/jsx-runtime";
import { useContext, useState, useEffect } from 'preact/hooks';
import { SingleOfferUnit, MultiOfferUnit, CustomOfferUnit } from './components';
import { SDKContext } from './context';
import { createDebugLogger } from './utils/debug';
const debug = createDebugLogger('App');
/**
 * Main App component that orchestrates different offer unit types.
 * Renders COU (Custom Offer Unit), SOU, or MOU based on configuration.
 *
 * Reads its store from per-instance SDKContext so multiple SDK instances can
 * render in parallel without sharing state.
 */
export function App(_props) {
    const ctx = useContext(SDKContext);
    const [unitType, setUnitType] = useState('SOU');
    useEffect(() => {
        if (!ctx)
            return;
        const { store } = ctx;
        const handleStoreChange = () => {
            const settings = store.getSettings();
            const offers = store.getOffers();
            if (settings?.is_cou) {
                setUnitType('COU');
            }
            else if (settings?.multi_offer_unit && offers.length > 1) {
                setUnitType('MOU');
            }
            else {
                setUnitType('SOU');
            }
        };
        store.on('change', handleStoreChange);
        store.on('settings-updated', handleStoreChange);
        store.on('offers-updated', handleStoreChange);
        handleStoreChange();
        return () => {
            store.off('change', handleStoreChange);
            store.off('settings-updated', handleStoreChange);
            store.off('offers-updated', handleStoreChange);
        };
    }, [ctx]);
    if (!ctx) {
        debug.error('SDKContext missing — component must be rendered inside an SDK provider.');
        return _jsx("div", {});
    }
    if (unitType === 'COU') {
        return _jsx(CustomOfferUnit, {});
    }
    if (unitType === 'MOU') {
        return _jsx(MultiOfferUnit, {});
    }
    return _jsx(SingleOfferUnit, {});
}
